import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';

// Capture the auth-link `type` from the URL hash at module load — BEFORE the
// supabase client's detectSessionInUrl parses and strips it. Invite / signup /
// recovery links arrive (implicit flow) as `#access_token=...&type=invite`
// (or `signup` / `recovery`). Normal logins and magic links carry no `type`.
// Consumers use this to force a set-password step instead of dropping a
// password-less session straight into the dashboard.
// Parse the auth-link `type` out of the current URL hash. Shared by the
// module-load capture below and the hashchange backup, so both read it the
// same way.
export const readAuthTypeFromHash = () => {
  try {
    const hash = window.location.hash?.startsWith('#')
      ? window.location.hash.slice(1)
      : '';
    return new URLSearchParams(hash).get('type');
  } catch {
    return null;
  }
};

export const initialAuthType = readAuthTypeFromHash();

// Link types that mean "this user has no usable password yet" and must set one
// before reaching the dashboard.
export const PASSWORD_SETUP_TYPES = ['invite', 'signup', 'recovery'];

export function useClientId() {
  const [clientId, setClientId] = useState(null);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    let mounted = true;

    supabase.auth.getSession().then(({ data }) => {
      if (!mounted) return;
      setClientId(data?.session?.user?.id ?? null);
      setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (!mounted) return;
      setClientId(session?.user?.id ?? null);
      setLoading(false);
    });

    return () => {
      mounted = false;
      subscription?.unsubscribe();
    };
  }, []);

  return { clientId, loading };
}
